import {NgModule} from '@angular/core';
import {PspdfkitModule} from '../pspdfkit/pspdfkit.module';
import {CommonModule} from '@angular/common';
import {UserDocumentViewRoutingModule} from './user-document-view.routing';
import {UserDocumentViewComponent} from './user-document-view.component';
import {UserDocumentComponent} from './user-document.component';

@NgModule({
  declarations: [
    UserDocumentComponent,
    UserDocumentViewComponent
  ],
  imports: [
    CommonModule,
    UserDocumentViewRoutingModule,
    PspdfkitModule
  ],
  providers: []
})
export class UserDocumentViewModule {
}
